<template>
<div>
  <el-header>Document reads</el-header>
  <el-message warning>
    Total: {{totalReads}}
  </el-message>

  <el-inline short />

  <el-inline
    space-between
    v-for="item in documentReads"
    :key="item.type"
  >
    <span>{{item.type}}</span>
    <span>{{item.value}}</span>
  </el-inline>

  <el-header>Update reports</el-header>
  <el-loader v-if="isPending" />
  <el-message info v-if="responseMessage !== ''">
    {{responseMessage}}
  </el-message>
  <el-button danger secondary margin-top
    @click="updateSubscriberReport"
    >
    Subscribers
  </el-button>
</div>
</template>
<script>
import api from 'services/api.js'

import logScope from 'log-scope'
const log = logScope('DatabaseMonitoring')

export default {
  data () {
    return {
      isPending: false,
      responseMessage: ''
    }
  },
  computed: {
    documentReads () {
      return Object.entries(this.$store.getters.documentReads)
        .map(([type, value]) => ({ type, value }))
        .sort((a, b) => b.value - a.value)
    },
    totalReads () {
      this.$nextTick(this.$forceUpdate)
      return this.$store.getters.totalDocumentReads
    }
  },
  methods: {
    async updateSubscriberReport () {
      this.isPending = true
      try {
        const res = await api.updateSubscriberReport()
        const message = res.data.message
        this.responseMessage = message
        log.success('Subscriber updated', message)
      } catch (err) {
        log.error('Could not updateSubscriberReport', err)
      }
      this.isPending = false
    }
  }
}
</script>
